import { get } from 'lodash';
import classNames from 'classnames';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { ForgeBadge, ForgeTab, ForgeTabBar } from '@tylertech/forge-react';
import { ITabBarChangeEventData } from '@tylertech/forge';

import { I18n } from 'common/i18n';
import UserNotificationList from 'common/notifications/components/UserNotifications/UserNotificationList';

const scope = 'shared.site_chrome.notifications';

interface TabsProps {
  clearAllUserNotifications: () => void;
  filterNotifications: (tab: string) => void;
  hasEnqueuedUserNotifications: boolean;
  hasError: boolean;
  onClearUserNotification: (notificationId: string) => void;
  onLoadMoreUserNotifications: () => void;
  onSeeNewUserNotifications: () => void;
  onToggleReadUserNotification: (notificationId: string) => void;
  openClearAllUserNotificationsPrompt: boolean;
  selectedTab: string;
  showUserNotifications: boolean;
  tabs: string[];
  toggleClearAllUserNotificationsPrompt: (open: boolean) => void;
  userNotifications: {
    activity: {
      unread: number;
      alerts: number;
    };
  };
  viewOlderLink: boolean;
}

interface TabsState {
  showAlertSettingModal: boolean;
}

export class Tabs extends Component<TabsProps, TabsState> {
  renderTabs() {
    const { filterNotifications, selectedTab, tabs } = this.props;

    const forgeTabs = tabs.map((tab, index) => this.renderTab(tab, index));
    let tabIndex = tabs.indexOf(selectedTab);
    tabIndex = tabIndex === -1 ? 0 : tabIndex;
    return (
      <ForgeTabBar
        activeTab={tabIndex}
        clustered
        underline
        on-forge-tab-bar-change={(event: CustomEvent<ITabBarChangeEventData>) =>
          filterNotifications(tabs[event.detail.index])
        }
      >
        {forgeTabs}
      </ForgeTabBar>
    );
  }

  renderTab = (tab: string, index: number) => {
    const unreadCount = this.unreadNotificationsCount(tab);
    return (
      <ForgeTab key={index}>
        {unreadCount > 0 && (
          <ForgeBadge slot="end" strong theme="tertiary">
            {unreadCount}
          </ForgeBadge>
        )}
        {I18n.t(`filter_${tab}_notifications_tab_text`, { scope })}
      </ForgeTab>
    );
  };

  unreadNotificationsCount = (tab: string) => {
    const { userNotifications } = this.props;
    let alertsAndNotificationsCount;
    switch (tab) {
      case 'activity':
        alertsAndNotificationsCount = get(userNotifications, 'activity.unread');
        break;
      case 'alert':
        alertsAndNotificationsCount = get(userNotifications, 'alert.unread');
        break;
    }
    return alertsAndNotificationsCount;
  };

  renderUserNotificationsList() {
    const {
      clearAllUserNotifications,
      hasEnqueuedUserNotifications,
      hasError,
      onClearUserNotification,
      onLoadMoreUserNotifications,
      onSeeNewUserNotifications,
      onToggleReadUserNotification,
      openClearAllUserNotificationsPrompt,
      selectedTab,
      toggleClearAllUserNotificationsPrompt,
      userNotifications,
      showUserNotifications,
      viewOlderLink,
    } = this.props;

    return (
      <UserNotificationList
        clearAllUserNotifications={clearAllUserNotifications}
        filterNotificationsBy={selectedTab}
        hasEnqueuedUserNotifications={hasEnqueuedUserNotifications}
        hasError={hasError}
        onClearUserNotification={onClearUserNotification}
        onLoadMoreUserNotifications={onLoadMoreUserNotifications}
        onSeeNewUserNotifications={onSeeNewUserNotifications}
        onToggleReadUserNotification={onToggleReadUserNotification}
        openClearAllUserNotificationsPrompt={openClearAllUserNotificationsPrompt}
        showUserNotifications={showUserNotifications}
        toggleClearAllUserNotificationsPrompt={toggleClearAllUserNotificationsPrompt}
        userNotifications={userNotifications}
        viewOlderLink={viewOlderLink}
      />
    );
  }

  render() {
    const { selectedTab } = this.props;
    const notificationItemsClassName = classNames('notification-items-wrapper');

    return (
      <div className="notification-panel">
        <div className="notification-tabs">{this.renderTabs()}</div>
        <div className={notificationItemsClassName} id={`${selectedTab}-notification-items`}>
          <div className="notification-items">{this.renderUserNotificationsList()}</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: { userId: any; configurations: { showUserNotifications: any } }) => ({
  userId: state.userId,
  showUserNotifications: state.configurations.showUserNotifications,
});

export default connect(mapStateToProps)(Tabs);
